'use strict';

let _=require('pulsar-utils/dist-es6/_');

const AnalyticsAccountId="UA-74554005-3";let

AnalyticsConfig=class AnalyticsConfig{
static get $inject(){
return['AnalyticsProvider'];
}

constructor(AnalyticsProvider){
let provider=AnalyticsProvider;

if(AnalyticsAccountId==='development'||
!_.exists(window)||
typeof window!='object'||
_.exists(process)&&process.browser!==!0){
provider.
logAllCalls(!0).
enterDebugMode(!0).
enterTestMode(!0).
delayScriptTag(!0);
}else{
provider.
setAccount(AnalyticsAccountId).
logAllCalls(!0).
setPageEvent('$locationChangeSuccess').
trackUrlParams(!0).
trackPages(!0).
ignoreFirstPageLoad(!1);
}
}};


module.exports=AnalyticsConfig;
module.exports.runFunction=(Analytics,$state)=>{
if(!_.exists(window)){
return;
}

const buildEntry=(title,val,mapper=_.identity)=>{
if(!_.exists(val)){
return void 0;
}
return`${title}: ${mapper(val)}`;
};

window.onerror=(message,file,line,column,error)=>{
const category=`error${_isExternalHost(file)?' (external)':''}`;
const action='unhandled (script)';
const label=_.compact([
buildEntry('MESSAGE',message),
buildEntry('ERROR',error,e=>e.stack||e.description||e.message||e),
buildEntry('FILE',file),
buildEntry('LINE',line),
buildEntry('COLUMN',column),
buildEntry('STATE',$state.current.name),
buildEntry('STATE PARAMS',_.isEmpty($state.params)?void 0:$state.params,p=>JSON.stringify(p))]).
join(' | ').replace(/[\r\n\t]+/g,' -> ').replace(/\s+/g,' ').trim();

Analytics.trackEvent(category,action,label);
};
};

module.exports.runFunction.$inject=['Analytics','$state'];

const _getFileHost=file=>{
const link=window.document.createElement('a');
link.href=file;
return link.hostname;
};

const _isExternalHost=file=>{
const host=_getFileHost(file);

return!(host==window.location.hostname||_.exists(host)||host=='');
};
//# sourceMappingURL=analyticsConfig.js.map
